export default {
  // tableNextReport
  selectedItem: (state:any) => {
    if (state.table.selectedItems.length === 1) {
      const { DT_RowId, DT_RowName, DT_RowWorkspaceId, ...restProps } = state.table.selectedItems[0]

      return {
        id: DT_RowId,
        name: DT_RowName,
        workspaceId: DT_RowWorkspaceId,
        ...restProps,
      }
    }

    return {}
  },
  tableQuerySearch(state: any, getters: any) {
    if(state.table.activeTab !==0){
      return state.table.activeReports[getters.activeReportIndex]?.state?.tableQuery?.search || {}
    }
    switch(state.user.reportSearchSetting) {
      case 'perTab':
        return state.table.query?.search?.[state.table.query.groupBy]  || {};
      case 'allTabs':
      default:
        return state.table.query.search || {}
    }
  },
  tableQueryTemporarySearch(state: any, getters: any) {
    if(state.table.activeTab !==0){
      return state.table.activeReports[getters.activeReportIndex]?.state?.tableQueryTemporary?.search || {}
    }
    switch(state.user.reportSearchSetting) {
      case 'perTab':
        return state.table.queryTemporary?.search?.[state.table?.query?.groupBy] || {};
      case 'allTabs':
      default:
        return state.table.queryTemporary.search || {}
    }
  },
  activeReportIndex(state: any, getters: any) {
    return state.table.activeReports.findIndex(report=>report.tabId === state.table.activeTab)
  },
  tableQueryForCurrentTab(state: any, getters: any) {
    if(state.table.activeTab !==0){
      return state.table.activeReports[getters.activeReportIndex]?.state?.tableQuery || {}
    }
    return state.table.query
  },
  tableQueryTemporaryForCurrentTab(state: any, getters: any) {
    if(state.table.activeTab !==0){
      return state.table.activeReports[getters.activeReportIndex]?.state?.tableQueryTemporary || {}
    }
    return state.table.queryTemporary
  },
  tableColumnsFiltersForCurrentTab(state: any, getters: any) {
    if(state.table.activeTab !==0){
      return state.table.activeReports[getters.activeReportIndex]?.state?.filters || {}
    }
    return state.table.filters
  },
  tableColumnsFiltersForCurrentTabInQueryFormat(state: any, getters: any) {
    const filterHaving = [];
    const filterHavingOptions = [];
    const filterHavingValues = [];

    Object.keys(getters.tableColumnsFiltersForCurrentTab).forEach((key)=> {
      filterHaving.push(key);
      filterHavingOptions.push(getters.tableColumnsFiltersForCurrentTab[key].filterHavingOptions);
      filterHavingValues.push(getters.tableColumnsFiltersForCurrentTab[key].filterHavingValues);
    });

    return {filterHaving, filterHavingOptions,filterHavingValues}
  },
};
